"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * User Registration Service
 * Provides endpoints for users to register for the EVE and SAVE on-boarding processes.<br><br> Users created here will have a role of REGISTRATION. Once created they login through the normal legacy-idp process at which point the applications direct them to their respective on-boarding process.
 *
 * The version of the OpenAPI document: 1.0.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemErrorCodeToJSON = exports.SystemErrorCodeFromJSONTyped = exports.SystemErrorCodeFromJSON = exports.SystemErrorCode = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var SystemErrorCode;
(function (SystemErrorCode) {
    SystemErrorCode["EMAILSENDFAILURE"] = "EMAIL_SEND_FAILURE";
    SystemErrorCode["GENERALSYSTEMERROR"] = "GENERAL_SYSTEM_ERROR";
})(SystemErrorCode = exports.SystemErrorCode || (exports.SystemErrorCode = {}));
function SystemErrorCodeFromJSON(json) {
    return SystemErrorCodeFromJSONTyped(json, false);
}
exports.SystemErrorCodeFromJSON = SystemErrorCodeFromJSON;
function SystemErrorCodeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SystemErrorCodeFromJSONTyped = SystemErrorCodeFromJSONTyped;
function SystemErrorCodeToJSON(value) {
    return value;
}
exports.SystemErrorCodeToJSON = SystemErrorCodeToJSON;
